exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-select{\r\n  padding-left: 15px;\r\n}\r\n\r\nmat-form-field{\r\n  padding-left: 15px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-add/user-add.component.css
// module id = ../../../../../src/app/users/user-add/user-add.component.css
// module chunks = main